import { createContext, useContext } from 'react';
import type { Workspace } from '../shared/domain/hotel';

export interface Toast { id: number; message: string; tone: 'success' | 'warning' | 'info' }
export interface WorkspaceContextValue {
    data: Workspace | null;
    error: string | null;
    loading: boolean;
    refresh: () => Promise<void>;
    notify: (message: string, tone?: Toast['tone']) => void;
    mutate: <T>(path: string, body: unknown, message: string, key?: string) => Promise<T>;
}
export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);
export function useWorkspace() {
    const value = useContext(WorkspaceContext);
    if (!value) throw new Error('WorkspaceProvider is missing.');
    return value;
}
export function useHotel() {
    const value = useWorkspace();
    if (!value.data) throw new Error('This screen needs a loaded workspace.');
    return { ...value, data: value.data };
}
